angular.module('unica_campaign.campaign_services')

.factory('CampaignCreateService', function($http, getBaseApiURL) {

	var campaignCreateService = {};

	campaignCreateService.create = function( eventId, campaignData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign/create/' + eventId,
			data: campaignData
		}).then(function(result) {

			if ( result ) {
				return result.data.campaign;
			}

		});
	};

	return campaignCreateService;

});